var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pessoa && !_vm.isSocio
        ? _c("el-row", { attrs: { span: 24 } }, [
            _vm.isPf
              ? _c(
                  "div",
                  { key: "pessoa-fisica", staticClass: "labelStyle" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.temCertidaoCasamento
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNumeroCertidaoCasamento
                                ? "text"
                                : "",
                              attrs: {
                                label: "Número da certidão de casamento:",
                                content:
                                  _vm.pessoa.pessoaFisica.certidaoCasamento
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.temCertidaoCasamento
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouDataCasamento
                                ? "text"
                                : "",
                              attrs: {
                                label: "Data de casamento:",
                                content: _vm.formatDate(
                                  _vm.pessoa.pessoaFisica.dataCasamento
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.cpf
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouNome
                                ? "text"
                                : "",
                              attrs: {
                                label: _vm.temCertidaoCasamento
                                  ? "Cônjuge/Companheiro(a):"
                                  : "Nome:",
                                content: _vm.pessoa.pessoaFisica.nome
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.cpf
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouCPF
                                ? "text"
                                : "",
                              attrs: {
                                label: "CPF:",
                                content: _vm.pessoa.pessoaFisica.cpf
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    !_vm.isProcessoFisico
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _vm.pessoa.pessoaFisica.apelido != null
                              ? _c("app-display", {
                                  class: _vm.compararInformacoesPessoa
                                    .mudouApelido
                                    ? "text"
                                    : "",
                                  attrs: {
                                    label: "Apelido:",
                                    content: _vm.pessoa.pessoaFisica.apelido
                                      ? _vm.pessoa.pessoaFisica.apelido
                                      : "-"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isProcessoFisico
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _vm.pessoa.pessoaFisica.nomeSocial != null
                              ? _c("app-display", {
                                  class: _vm.compararInformacoesPessoa
                                    .mudouNomeSocial
                                    ? "text"
                                    : "",
                                  attrs: {
                                    label: "Nome Social:",
                                    content: _vm.pessoa.pessoaFisica.nomeSocial
                                      ? _vm.pessoa.pessoaFisica.nomeSocial
                                      : "-"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isProcessoFisico
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: "Tipo de documento:",
                                content:
                                  _vm.pessoa.pessoaFisica.tipoDocumento || "-"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isProcessoFisico
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _vm.pessoa.pessoaFisica.tipoDocumento == "OUTROS"
                              ? _c("app-display", {
                                  attrs: {
                                    label: "Outros:",
                                    content:
                                      _vm.pessoa.pessoaFisica
                                        .outrosTipoDocumento
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.rg
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouRG
                                ? "text"
                                : "",
                              attrs: {
                                label: "RG:",
                                content: _vm.pessoa.pessoaFisica.rg
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.orgaoExpedidor
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouOrgaoExpedidor
                                ? "text"
                                : "",
                              attrs: {
                                label: "Órgão expedidor:",
                                content: _vm.getOrgaoExpedidor(
                                  _vm.pessoa.pessoaFisica.orgaoExpedidor
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.nacionalidade
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNacionalidade
                                ? "text"
                                : "",
                              attrs: {
                                label: "Nacionalidade:",
                                content: _vm.getGentilico(
                                  _vm.pessoa.pessoaFisica.nacionalidade
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.pessoa.pessoaFisica.estadoCivil
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            !_vm.isConjuge && !_vm.isAmapa
                              ? _c("app-display", {
                                  class: _vm.compararInformacoesPessoa
                                    .mudouEstadoCivil
                                    ? "text"
                                    : "",
                                  attrs: {
                                    label: "Estado civil:",
                                    content: _vm.getEstadoCivil(
                                      _vm.pessoa.pessoaFisica.estadoCivil
                                    )
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.data
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouDataNascimento
                                ? "text"
                                : "",
                              attrs: {
                                label: "Data de nascimento:",
                                content: _vm.data
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.isConjuge
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouDataNascimento
                                ? "text"
                                : "",
                              attrs: {
                                label: "Data de nascimento:",
                                content: _vm.formatDate(
                                  _vm.pessoa.pessoaFisica.dataNascimento
                                )
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.sexo
                          ? _c("app-display", {
                              attrs: {
                                label: "Sexo:",
                                content: _vm.formatarTexto(
                                  _vm.pessoa.pessoaFisica.sexo
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.municipio ||
                        _vm.pessoa.pessoaFisica.naturalidade
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNaturalidade
                                ? "text"
                                : "",
                              attrs: {
                                label: "Naturalidade:",
                                content: _vm.getNaturalidade(
                                  _vm.pessoa.pessoaFisica
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        !_vm.isConjuge
                          ? _c("app-display-multiple", {
                              class: _vm.compararInformacoesPessoa
                                .mudouTelefones
                                ? "text"
                                : "",
                              attrs: {
                                label: "Telefone(s):",
                                content: _vm.formatTelefone(
                                  _vm.pessoa.telefones
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.nomeDaMae && !_vm.isBahia
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNomeDaMae
                                ? "text"
                                : "",
                              attrs: {
                                label: "Nome da mãe:",
                                content: _vm.pessoa.pessoaFisica.nomeDaMae
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.nomeDoPai && !_vm.isBahia
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNomeDoPai
                                ? "text"
                                : "",
                              attrs: {
                                label: "Nome do pai:",
                                content: _vm.pessoa.pessoaFisica.nomeDoPai
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.rendaFamiliar
                          ? _c("app-display", {
                              class: _vm.compararRendaFamiliar ? "text" : "",
                              attrs: {
                                label: "Renda familiar:",
                                content: _vm.rendaFamiliar.includes("R$")
                                  ? _vm.rendaFamiliar
                                  : "R$ " + _vm.rendaFamiliar
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.profissao && !_vm.isBahia
                          ? _c("app-display", {
                              attrs: {
                                label: "Profissão:",
                                content: _vm.pessoa.pessoaFisica.profissao
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.filhoMenorDe16 === true ||
                        _vm.pessoa.pessoaFisica.filhoMenorDe16 === false
                          ? _c("app-display", {
                              attrs: {
                                label: "Possui filho menor de 16 anos:",
                                content: _vm.pessoa.pessoaFisica.filhoMenorDe16
                                  ? "Sim"
                                  : "Não"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoaFisica.tempoMoradia
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouTempoMoradia
                                ? "text"
                                : "",
                              attrs: {
                                label: "Tempo moradia:",
                                content:
                                  _vm.pessoa.pessoaFisica.tempoMoradia + " anos"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        !_vm.isConjuge && !_vm.isProcessoFisico
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouEmail
                                ? "text"
                                : "",
                              attrs: {
                                label: "E-mail:",
                                isArray: _vm.isBahia,
                                content: _vm.isBahia
                                  ? _vm.pessoa.emails
                                  : _vm.getEmail(_vm.pessoa.email)
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.isBahia
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _vm.pessoa.pessoaFisica.profissao
                              ? _c("app-display", {
                                  attrs: {
                                    label: "Profissão:",
                                    content:
                                      _vm.pessoa.pessoaFisica.profissao ===
                                      "OUTRA"
                                        ? _vm.pessoa.pessoaFisica.outraProfissao
                                        : _vm.pessoa.pessoaFisica.profissao
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isBahia
                      ? _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("app-divider", {
                              staticClass: "margin-bottom",
                              attrs: { label: "Filiação" }
                            }),
                            _c(
                              "el-col",
                              {
                                staticClass: "margin-bottom",
                                attrs: { span: 12 }
                              },
                              [
                                _vm.pessoa.pessoaFisica.nomeDaMae
                                  ? _c("app-display", {
                                      class: _vm.compararInformacoesPessoa
                                        .mudouNomeDaMae
                                        ? "text"
                                        : "",
                                      attrs: {
                                        label: "Nome da Mãe:",
                                        content:
                                          _vm.pessoa.pessoaFisica.nomeDaMae
                                      }
                                    })
                                  : _vm._e(),
                                _vm.pessoa.pessoaFisica.nomeDoPai
                                  ? _c("app-display", {
                                      class: _vm.compararInformacoesPessoa
                                        .mudouNomeDoPai
                                        ? "text"
                                        : "",
                                      attrs: {
                                        label: "Nome do Pai:",
                                        content:
                                          _vm.pessoa.pessoaFisica.nomeDoPai
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.dadosInteressadoRr
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _vm.dadosInteressadoRr.possuiFilhoMenor !==
                                undefined
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "Possui filho menor de 18 anos de idade?",
                                        content: _vm.dadosInteressadoRr
                                          .possuiFilhoMenor
                                          ? "Sim"
                                          : "Não"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _vm.dadosInteressadoRr.profissao
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "Profissão:",
                                        content:
                                          _vm.dadosInteressadoRr.profissao
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _vm.dadosInteressadoRr.tipoRegimeEmpregaticio
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "Regime empregatício:",
                                        content:
                                          _vm.dadosInteressadoRr
                                            .tipoRegimeEmpregaticio
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isPf
              ? _c(
                  "div",
                  { key: "pessoa-juridica" },
                  [
                    _c(
                      "el-row",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouCNPJ
                                ? "text"
                                : "",
                              attrs: {
                                label: "CNPJ:",
                                content: _vm.pessoa.pessoaJuridica.cnpj
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouRazaoSocial
                                ? "text"
                                : "",
                              attrs: {
                                label: _vm.razaoSocialName,
                                content: _vm.pessoa.pessoaJuridica.razaoSocial
                              }
                            })
                          ],
                          1
                        ),
                        !_vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("app-display-multiple", {
                                  class: _vm.compararInformacoesPessoa
                                    .mudouTelefones
                                    ? "text"
                                    : "",
                                  attrs: {
                                    label: "Telefone(s):",
                                    content: _vm.pessoa.telefones
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge
                                  ? _c("app-display", {
                                      class: _vm.compararInformacoesPessoa
                                        .mudouEmail
                                        ? "text"
                                        : "",
                                      attrs: {
                                        label: "E-mail:",
                                        content: _vm.pessoa.email
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "Nome do presidente da associação/empresa:",
                                        content:
                                          _vm.pessoa.pessoaJuridica
                                            .presidenteAssociacao.nome
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "CPF do presidente da associação/empresa:",
                                        content:
                                          _vm.pessoa.pessoaJuridica
                                            .presidenteAssociacao.cpf
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "RG do presidente da associação/empresa:",
                                        content:
                                          _vm.pessoa.pessoaJuridica
                                            .presidenteAssociacao.rg || "-"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "Tipo de documento:",
                                        content:
                                          _vm.pessoa.pessoaJuridica
                                            .presidenteAssociacao
                                            .tipoDocumento || "-"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge &&
                                _vm.pessoa.pessoaJuridica.presidenteAssociacao
                                  .tipoDocumento == "OUTROS"
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "Outros:",
                                        content:
                                          _vm.pessoa.pessoaJuridica
                                            .presidenteAssociacao
                                            .outrosTipoDocumento || "-"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isProcessoFisico
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                !_vm.isConjuge
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "Órgão expedidor:",
                                        content: _vm.getOrgaoExpedidor(
                                          _vm.pessoa.pessoaJuridica
                                            .presidenteAssociacao.orgaoExpedidor
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.pessoa && _vm.isSocio
        ? _c("el-row", { attrs: { span: 24 } }, [
            _vm.pessoa.pessoa.isPessoaFisica
              ? _c(
                  "div",
                  { key: "pessoa-fisica" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          class: _vm.compararInformacoesPessoa.mudouNome
                            ? "text"
                            : "",
                          attrs: {
                            label: "Nome:",
                            content: _vm.pessoa.pessoa.pessoaFisica.nome
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          class: _vm.compararInformacoesPessoa.mudouCPF
                            ? "text"
                            : "",
                          attrs: {
                            label: "CPF:",
                            content: _vm.pessoa.pessoa.pessoaFisica.cpf
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.rg
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouRG
                                ? "text"
                                : "",
                              attrs: {
                                label: "RG:",
                                content: _vm.pessoa.pessoa.pessoaFisica.rg
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.funcao
                          ? _c("app-display", {
                              attrs: {
                                label: "Função:",
                                content: _vm.getFuncao(_vm.pessoa.funcao)
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.nacionalidade
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNacionalidade
                                ? "text"
                                : "",
                              attrs: {
                                label: "Nacionalidade:",
                                content: _vm.getGentilico(
                                  _vm.pessoa.pessoa.pessoaFisica.nacionalidade
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.email
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouEmail
                                ? "text"
                                : "",
                              attrs: {
                                label: "E-mail:",
                                content: _vm.pessoa.pessoa.email
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          class: _vm.compararInformacoesPessoa.mudouEstadoCivil
                            ? "text"
                            : "",
                          attrs: {
                            label: "Estado civil:",
                            content: _vm.getEstadoCivil(
                              _vm.pessoa.pessoa.pessoaFisica.estadoCivil
                            )
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.data
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouDataNascimento
                                ? "text"
                                : "",
                              attrs: {
                                label: "Data de nascimento:",
                                content: _vm.data
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.orgaoExpedidor
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouOrgaoExpedidor
                                ? "text"
                                : "",
                              attrs: {
                                label: "Órgão expedidor:",
                                content: _vm.getOrgaoExpedidor(
                                  _vm.pessoa.pessoa.pessoaFisica.orgaoExpedidor
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.municipio
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNaturalidade
                                ? "text"
                                : "",
                              attrs: {
                                label: "Naturalidade:",
                                content: _vm.getNaturalidade(
                                  _vm.pessoa.pessoa.pessoaFisica
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.isSocioRepresentanteLegal !== null &&
                        _vm.pessoa.isSocioRepresentanteLegal !== ""
                          ? _c("app-display", {
                              class: _vm.compararIsSocioRepresentanteLegal
                                ? "text"
                                : "",
                              attrs: {
                                label: "O sócio é representante legal?",
                                content: _vm.pessoa.isSocioRepresentanteLegal
                                  ? "Sim"
                                  : "Não"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pessoa.pessoa.pessoaFisica.nomeDaMae
                          ? _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouNomeDaMae
                                ? "text"
                                : "",
                              attrs: {
                                label: "Nome da mãe:",
                                content:
                                  _vm.pessoa.pessoa.pessoaFisica.nomeDaMae
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display-multiple", {
                          class: _vm.compararInformacoesPessoa.mudouTelefones
                            ? "text"
                            : "",
                          attrs: {
                            label: ":",
                            content: _vm.pessoa.pessoa.telefones
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.pessoa.pessoa.isPessoaFisica
              ? _c(
                  "div",
                  { key: "pessoa-juridica" },
                  [
                    _c(
                      "el-row",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa.mudouCNPJ
                                ? "text"
                                : "",
                              attrs: {
                                label: "CNPJ:",
                                content: _vm.pessoa.pessoa.pessoaJuridica.cnpj
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              class: _vm.compararInformacoesPessoa
                                .mudouRazaoSocial
                                ? "text"
                                : "",
                              attrs: {
                                label: _vm.razaoSocialName,
                                content:
                                  _vm.pessoa.pessoa.pessoaJuridica.razaoSocial
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display-multiple", {
                              class: _vm.compararInformacoesPessoa
                                .mudouTelefones
                                ? "text"
                                : "",
                              attrs: {
                                label: "Telefone(s):",
                                content: _vm.pessoa.pessoa.telefones
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            !_vm.isConjuge
                              ? _c("app-display", {
                                  class: _vm.compararInformacoesPessoa
                                    .mudouEmail
                                    ? "text"
                                    : "",
                                  attrs: {
                                    label: "E-mail:",
                                    content: _vm.pessoa.email
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1736a516", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1736a516","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesPessoa.vue
// module id = null
// module chunks = 